import {createMemoryHistory} from 'history';

import {API} from '@kouch.tv/brandis-api';
import {ApplicationModel, IApplicationChildModels} from '@kouch.tv/brandis-application';

import {getMessagesForLocale, AVAILABLE_LOCALES} from 'src/intl';

import {PlatformModel} from './platform';
import {RuntimeModel} from './runtime';

declare global {
	interface Window {
		Brandis: {
			api?: API;
			application?: TApplicationModel;
		};
	}
}

export interface IApplicationSelfChildModels extends IApplicationChildModels {
	platform?: PlatformModel,
	runtime?: RuntimeModel,
}

export type TApplicationModel = ApplicationModel<IApplicationSelfChildModels>;

export const api: API = new API({enable: {socket: {bro: true, cmd: true}}});

export const application: TApplicationModel = new ApplicationModel<IApplicationSelfChildModels>(api);

application
	.setModel('runtime', RuntimeModel)
	.setModel('platform', PlatformModel)
	.getModel('navigation')
	.setHistory(createMemoryHistory())
	.application
	.getModel('environment')
	.setLocaleSettingsAvailable(Object.values(AVAILABLE_LOCALES))
	.application
	.getModel('intl')
	.setMessagesLoader(getMessagesForLocale)
	.application
	.initialize();

(function (window, api, application) {
	'use strict';
	window.Brandis = window.Brandis || {};
	window.Brandis.api = api;
	window.Brandis.application = application;
}(window, api, application));

export * from './runtime';
export * from './platform';
